
import getCartAction from "./getCartAction";
import syncOrderLineRequest from "../requests/syncOrderLineRequest";
import getNewOrderRequest from "../requests/getNewOrderRequest";

const cartFetchRequired = (order) => {
    return !order || order.DocStatus.id === "CO";
}

const getCartID = async (session, get, forceFetchNewCart) => {
    const activeCart = get().order;
    if(forceFetchNewCart || cartFetchRequired(activeCart)) {
        const newCart = await getNewOrderRequest(session);
        return newCart.id;
    }

    return activeCart.id;
}

const addItemToCart = async (session, cartItem, get, forceFetchNewCart) => {
    const orderID = await getCartID(session, get, forceFetchNewCart);
    console.log("oID", orderID);
    return await syncOrderLineRequest(session, cartItem, orderID);
}

const newCartRequired = (error) => {
    return error.response
        && error.response.data
        && error.response.data.detail
        && error.response.data.detail.startsWith("Save error with exception: Foreign ID");
}

const addItemToCartWithRetry = async (session, cartItem, get) => {
    try {
        return await addItemToCart(session, cartItem, get);
    } catch (error) {
        if(newCartRequired(error)) {
            return await addItemToCart(session, cartItem, get, true);
        } else {
            throw error;
        }
    }
}

const syncCartLineAction = async (session, cartRecord, set, get) => {
    await addItemToCartWithRetry(session, cartRecord, get);
    return await getCartAction(session, false, get);
}

export default syncCartLineAction;